import { ReferralPage } from "~/components/referral/ReferralPage";
import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbSchema, structuredDataScript } from "~/utils/structuredData";

export const Route = createFileRoute("/patients-refer-a-friend")({
	head: () => ({
		meta: [
			{ title: "Patients: Refer a Friend - Miami Orthodontic Specialists" },
			{
				name: "description",
				content:
					"Share a smile with a friend. Refer a patient to Miami Orthodontic Specialists.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://miamibraces.com/patients-refer-a-friend/",
			},
		],
		scripts: [
			structuredDataScript([
				breadcrumbSchema(
					"https://miamibraces.com/patients-refer-a-friend/",
					"Refer a Friend",
				),
			]),
		],
	}),
	component: ReferralPage,
});
